"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpiredFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const button_1 = __importDefault(require("@kawaui/button"));
const footer_1 = require("../styles/footer");
const constants_1 = require("../utils/constants");
const hooks_1 = require("../utils/hooks");
const ExpiredFooter = ({ showReopen, onRouting }) => {
    const { cancelRecoverCartConnected } = (0, provider_1.useCartActions)();
    const { i18n } = (0, hooks_1.useTranslate)();
    const handleCartReview = () => {
        onRouting(constants_1.CART_PAGE);
    };
    const handleDiscard = () => {
        cancelRecoverCartConnected();
    };
    return ((0, jsx_runtime_1.jsxs)(footer_1.FooterContainer, { children: [(0, jsx_runtime_1.jsx)(footer_1.AnchorContainer, { children: (0, jsx_runtime_1.jsxs)(footer_1.AnchorWrapper, { children: [(0, jsx_runtime_1.jsx)(button_1.default, { size: "medium", isFullWidth: true, variant: "tertiary", onClick: handleDiscard, children: i18n('cart_widget.expired.cta.2') }), (0, jsx_runtime_1.jsx)(footer_1.Space, {}), (0, jsx_runtime_1.jsx)(button_1.default, { size: "medium", isFullWidth: true, onClick: handleCartReview, children: i18n('cart_widget.expired.cta.1') })] }) }), showReopen && (0, jsx_runtime_1.jsx)(footer_1.ReOpenOrderLabel, { children: i18n('cart_widget.reopen_order.text') })] }));
};
exports.ExpiredFooter = ExpiredFooter;
exports.default = exports.ExpiredFooter;
